/* Item styling moved to Interstate Tailwind utility classes in SupportMenuItem.ts's
   markup. Only the typography with no preset-token equivalent remains here (font
   families + line-heights, near-black title colour). The base/utilities layer comes
   from the shared ../../../styles/tailwind-shared.css import in SupportMenuItem.ts
   (ARGUS PR #164 CRITICAL). This item renders no `.ids-*` classes, so — like
   SupportMenuPanel.css — it does NOT import the components layer (ARGUS PR #164
   MAJOR: the old standalone `@tailwind components` here was dead CSS). */

:host {
  display: block;
}

/* Typography with no clean preset-token utility (kept as component-local tokens). */
.item-title {
  font-family: var(--sm-title-font-family, "IBM Plex Sans", sans-serif);
  color: var(--sem-color-on-surface-default, #151516);
  line-height: 1.3;
}

.item-subtitle {
  font-family: var(--sm-subtitle-font-family, "Inter", sans-serif);
  line-height: 1.4;
}
